import { appstr } from "../utils/appstr";
import { QAlert } from "./QAlert";
import { QPoint } from "./QPoint";
import { QRFC } from "./QRFC";

export class QPointInTimeRFC extends QRFC {
  constructor() {
    super();
  }

  InitQPointInTimeRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qmongorfc";
  }

  SetParams(orgName, userName, mode, data, chartID) {
    this.AddParameter("chartID", chartID);
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];
    var code = r["code"];
    var loadData = "data" in r && JSON.parse(r["data"]);
    var msg = r["message"];
    var delta = r["deltafilename"];

    var wsMgr = callBackObj.fWSMgr;

    if (success && loadData && loadData["mode"] === "loadPointInTime") {
      wsMgr.SetPointInTime(loadData["archiveInfo"]);
      if (wsMgr.fWaiting) {
        wsMgr.ClearAppLoadingAnimation();
        wsMgr.fWaiting = null;
      }
      callBackObj?.resolve(r);
      wsMgr.PrepRenderWS();
      wsMgr.RenderWS();
      return;
    }

    if (success) {
      callBackObj?.resolve(r);
    }
    if (wsMgr.fWaiting) {
      wsMgr.ClearAppLoadingAnimation();
      wsMgr.fWaiting = null;
    }

    if (success && loadData) {
      callBackObj.fWSMgr.SetPointInTime(loadData);
    }

    switch (code) {
      case "0000":
        msg = appstr("archivesuccess");
        break;
      case "0001":
        msg = appstr("archiveloadsuccess");
        break;
      case "9994":
        msg = appstr("archivenotfound");
        break;
      case "9995":
        msg = appstr("deltaerr");
        break;
      case "9996":
        msg = appstr("archivenotfound");
        break;
      case "9997":
        msg = appstr("invalidrange");
        break;
      case "9998":
        msg = appstr("deltafailure");
        break;
      case "9999":
        msg = appstr("archivefail");
        break;
      case "9993":
        msg = appstr("exportnotfound");
        break;
      case "9992":
        msg = appstr("exportfailure");
        break;
    }
    if (delta) {
      // Delta reports and PIT archive exportsreturn a single downloadable file here
      wsMgr.ExcelDBResult(success, delta);
    }
    if (code) {
      var alert = new QAlert();
      alert.InitAlert(appstr("Alert"), msg, null, wsMgr);
    }

    callBackObj.fRFCActive = false;

    wsMgr.PrepRenderWS();
    wsMgr.RenderWS();

    if (!success) {
      callBackObj?.reject?.(msg);
    }
  }
}
